function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm-.003-8.065a1.007 1.007 0 001-1.064c-.003-.055-.058-1.353 1.392-2.527C15.503 11.442 16 10.426 16 9.05c0-2.265-1.795-4.107-4-4.107-2.243 0-4 1.757-4 4a1 1 0 002 0c0-1.141.86-2 2-2 1.103 0 2 .945 2 2.107 0 .764-.228 1.219-.87 1.738-2.309 1.87-2.134 4.147-2.126 4.243.046.519.48.903.993.903zM11.991 19a1 1 0 00.984-.83l.01-.057c.094-.544-.276-1.033-.82-1.127-.548-.095-1.066.3-1.16.844a1 1 0 00.986 1.17z"
});

var SvgIconHelpFilled = function SvgIconHelpFilled(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgIconHelpFilled;